import { render } from "./RequestApproveList.vue?vue&type=template&id=5ec6d72c"
import script from "./RequestApproveList.vue?vue&type=script&lang=js"
export * from "./RequestApproveList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__